import { render, staticRenderFns } from "./CollectionSlotSelection.vue?vue&type=template&id=7edd758a&scoped=true&"
import script from "./CollectionSlotSelection.vue?vue&type=script&lang=ts&"
export * from "./CollectionSlotSelection.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionSlotSelection.vue?vue&type=style&index=0&id=7edd758a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edd758a",
  null
  
)

export default component.exports